import { useCallback } from "react";
import { useFetcher } from "react-router";

import type { action } from "~/routes/resources/learning-center-award";

const RESOURCE_URL = "/resources/learning-center-award";

/**
 * Fire the AnnexCloud level-complete award (SFCC-11505). The state machine calls
 * `awardLevelPoints(loyaltyActionId)` once `updateQuiz` reports the parent level
 * complete. All gating (loyalty site, enrollment, configured action group),
 * the Annex calls, and the `c_acLoyaltyData` profile write happen server-side in
 * the resource action — this hook only forwards the level's `loyaltyActionId`.
 *
 * Fire-and-forget by design: the player UI (passed block + CTA) does not block
 * on the award, so a slow/failed credit never stalls module completion. Resource
 * routes are absolute + not locale-segmented in this storefront, so no `useURL`
 * (consistent with `use-learning-center` / `use-fetch-lms`).
 */
export default function useAwardLevelPoints() {
  const fetcher = useFetcher<typeof action>();

  const awardLevelPoints = useCallback(
    (loyaltyActionId: string | null | undefined) => {
      if (!loyaltyActionId) return;
      fetcher.submit(
        { actionId: loyaltyActionId },
        { action: RESOURCE_URL, method: "post" },
      );
    },
    [fetcher],
  );

  return { awardLevelPoints, awardData: fetcher.data };
}
